<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="4">
          <!-- md="8" -->
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm v-if="false">
                  <h1>Login</h1>
                  <p class="text-muted">Login with your ScanCom account</p>
                  <CInput
                    placeholder="Email"
                    autocomplete="email"
                    v-model="model.email"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    v-model="model.password"
                    @keyup.enter="login"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CSpinner
                        v-if="loading"
                        color="info"
                        size="sm"
                        class="ml-2"
                      />
                      <CButton
                        v-else
                        color="primary"
                        class="px-4"
                        @click="login"
                      >
                        Login
                      </CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton
                        color="link"
                        class="px-0"
                        @click="forgotPassword"
                      >
                        Forgot password
                      </CButton>
                      <CButton v-if="false" color="link" class="d-lg-none">
                        Register now!
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
                <div v-else>
                  <h3 class="text-center">SCANCOM PORTAL</h3>
                  <div class="form-group">
                    <button
                      class="d-flex w-100 p-4 login-button"
                      @click.prevent="handleRedirectLogin"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 23 23"
                      >
                        <path fill="#f3f3f3" d="M0 0h23v23H0z" />
                        <path fill="#f35325" d="M1 1h10v10H1z" />
                        <path fill="#81bc06" d="M12 1h10v10H12z" />
                        <path fill="#05a6f0" d="M1 12h10v10H1z" />
                        <path fill="#ffba08" d="M12 12h10v10H12z" />
                      </svg>
                      <span> Login with ScanCom Account </span>
                    </button>
                  </div>
                </div>
              </CCardBody>
            </CCard>
            <CCard
              v-if="false"
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>Sign up</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <CButton color="light" variant="outline" size="lg">
                  Register Now!
                </CButton>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
      loading: false,
    };
  },
  computed: {
    returnUrl() {
      return this.$route.query.returnUrl;
    },
  },
  methods: {
    async login() {
      this.loading = true;
      try {
        let email = this.model.email;
        let password = this.model.password;
        let resp = await this.$user.dispatch("login", {
          UserName: email,
          Password: password,
        });

        if (resp.data.status == this.$const.RESPONSE_TYPES.Success) {
          //this.$router.push(this.returnUrl ? this.returnUrl : "/");
          let href = this.returnUrl ? this.returnUrl : "/";
          location.href = href;
        } else if (resp.data.message) {
          this.$swal(this.$const.MESSAGE[resp.data.message]);
        }
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: error,
        });
      }
      this.loading = false;
    },
    forgotPassword() {
      this.$swal("Please contact to your system admin to reset password!");
    },

    handleRedirectLogin() {
      // return console.log(`http://localhost:5173/login?request_url=${location.origin + route.query.returnUrl}`)
      window.location.replace(
        `https://pim.scancom.net/login?request_url=${
          location.origin + this.$route.query.returnUrl
        }`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.login-button {
  margin-top: 2rem;
  background-color: rgb(233, 233, 233);
  border: none;
  border-radius: 0.25rem;
  align-items: center;
  justify-content: center;
  color: rgb(49, 49, 49);

  svg {
    width: 20px;
    margin-right: 0.5rem;
  }
}
</style>
